<template>
    <div class="content-full-h">
        <div class="volets content mt-2">
            <div class="volet" v-for="(volet,key) in story.voletsContent.get()" :key="key" :class="[story.voletsContent.isActive(key) ? 'active' : '', volet.type]"
                 @click="story.voletsContent.setActive(key)">
                <div class="text">
                    <i class="fal" :class="$store.getters.iconByType(volet.type)"></i>
                    {{ $t(volet.label) }}
                </div>
                <div v-html="css"></div>
            </div>
        </div>
        <div class="volets-content full-h overflow-y-auto">
            <Story_Card
                :type="story.voletsContent.getCurrent().type"
                :story="story"
                :can-delete="true"
                @add="add"
                @select="select"
                @remove="remove"
            />
        </div>
    </div>
</template>

<script>
import {story} from "@/class/story";
import Story_Card from "@/views/story/Story_Cards";
import {storedOnglets,onglets} from "../../class/onglets/onglets"
import AnnotationList from "@/modules/annotation/annotation-list";

export default {
    name: "Story_Content",
    components: {AnnotationList, Story_Card},
    props:{
        story:{type:Object,default:()=>new story()}
    },
    data(){
        return{
            search:""
        }
    },
    methods:{
        async add(){
            let type = this.story.voletsContent.getCurrent().type
    
            if(!this.$store.getters.type(type).canEdit){
                this.$vs.dialog({
                    color: 'primary',
                    title: this.$t('Information'),
                    text: this.$t("It is not possible to create a "+this.$store.getters.type(type).label+" for the moment"),
                    acceptText: this.$t('Ok')
                })
                return;
            }
            
            if(type === "annotation"){
                await this.story.load();
                return;
            }
            
            this.$router.push("/story/"+this.story.getId()+"/"+this.$store.getters.routeByType(type)+"/0")
            
        },
        async select(item){
            if(!item.geGlobalInfoObject().canEdit){
                this.$vs.dialog({
                    color: 'primary',
                    title: this.$t('Information'),
                    text: this.$t("It is not possible to edit a "+item.getLabelObject()+" for the moment"),
                    acceptText: this.$t('Ok')
                })
                return;
            }
            if(item.getObjectType() === "annotation"){
                // await this.story.load();
                return;
            }
            
            this.$router.push(item.getRoute())
        },
        remove(item){
            item.ongletClose();
            item.delete().then(() => {
                this.story.load();
            });
        },
    },
    computed:{
        css(){
            let type = this.story.voletsContent.getCurrent().type
            return "<style>:root { --cActiveSub : "+this.$store.getters.colorByType(type)+";}</style>"
        }
    }
}
</script>